<template>
  <div class="td" :class="data.className">
    <span v-if="data.caption" class="heading"
      ><i v-if="data.icon" :class="`icon-${data.icon}`"></i>{{ data.caption }} <small v-if="data.sub">{{ data.sub }}</small></span
    >
    <span v-if="data.value" class="heading"
      ><AnimatedValue v-if="data.value" :value="data.value" :to-fixed-value="data.toFixedValue" /> <small v-if="data.sub">{{ data.sub }}</small></span
    >
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimatedValue';
export default {
  components: {
    AnimatedValue,
  },

  props: ['data'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
i {
  font-size: 1em;
}
.current-site-value {
  height: 24px;
  padding: 8px 0;
  margin: 8px 0 0;
  border-bottom: solid 1px #e3e3e3;
  border-top: solid 1px #e3e3e3;
}
</style>
